/**
 * Thin wrapper around the Telegram Mini App JS SDK (loaded via the
 * `telegram-web-app.js` script tag in index.html). Falls back gracefully
 * when running outside Telegram (plain browser dev) so local development
 * doesn't require a Telegram client.
 */

interface TelegramWebApp {
  initData: string;
  ready: () => void;
  expand: () => void;
  setHeaderColor: (color: string) => void;
  setBackgroundColor: (color: string) => void;
  colorScheme: "light" | "dark";
  platform: string;
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TelegramWebApp };
  }
}

export function getTelegramWebApp(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

/**
 * Returns the RAW initData string to send to the Worker for verification.
 * The frontend must never parse this itself and send individual fields —
 * only the Worker, holding BOT_TOKEN, can verify the signature.
 */
export function getRawInitData(): string | null {
  const webApp = getTelegramWebApp();
  return webApp?.initData || null;
}

export function initializeTelegramUi(): void {
  const webApp = getTelegramWebApp();
  if (!webApp) return;
  webApp.ready();
  webApp.expand();
  webApp.setHeaderColor("#05090C");
  webApp.setBackgroundColor("#05090C");
}
